import {
    DEVICE_REQUEST_FAILURE,
    DEVICE_REQUEST_START,
    DEVICE_REQUEST_SUCCESS,
} from '../actions/actionTypes';
import storePersist from "../storePersist";

export const initialState = {
    isLoading: false,
    errorMessage: null
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case DEVICE_REQUEST_START:
            return {
                ...state,
                isLoading: true,
                errorMessage: null,
            };
        case DEVICE_REQUEST_SUCCESS:
            const data = {
                ...state,
                isLoading: false,
                errorMessage: null
            };
            return data
        case DEVICE_REQUEST_FAILURE:
            return {
                ...state,
                isLoading: false,
                errorMessage: null,
            };

        default:
            return state;
    }
};